export default "__VITE_ASSET__DRnor123__"